import React from 'react'

const TruckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 60 60" {...props}>
    <circle cx="30" cy="30" r="30" fill="#DA291C" />

    <g
      clipPath="url(#clip0)"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none">
      <path d="M35.25 25.5h3.992c.149 0 .295.045.419.128.124.084.22.202.276.341L41.25 29.25" />
      <path d="M20.25 31.5H35.25" />
      <path d="M36 38.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" />
      <path d="M25.5 38.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" />
      <path d="M33.75 36h-6" />
      <path d="M35.25 29.25h6V35.25c0 .199-.079.39-.22.53A.75.75 0 0 1 40.5 36H38.25" />
      <path d="M23.25 36H21a.75.75 0 0 1-.75-.75V24.75A.75.75 0 0 1 21 24h14.25v9.878" />
    </g>

    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" transform="translate(18 18)" />
      </clipPath>
    </defs>
  </svg>
)

export default TruckIcon
